import { useEffect } from "react";

const Logout = () => {
    useEffect(() => {
        localStorage.removeItem("token");
        /*
        localStorage.removeItem("registration");
        localStorage.removeItem("notifyby");
        localStorage.removeItem("utype");
        */
        localStorage.removeItem("language");
        localStorage.removeItem("theme");
        window.location.replace('/');
    }, []);
    return null;
};

export default Logout;
